let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8yfIj")).then(() => parcelRequire('7ROZZ'));